import { render, staticRenderFns } from "./RatingUse.vue?vue&type=template&id=50e65730&"
import script from "./RatingUse.vue?vue&type=script&lang=js&"
export * from "./RatingUse.vue?vue&type=script&lang=js&"
import style0 from "./RatingUse.vue?vue&type=style&index=0&id=50e65730&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports